import { JobStatusHeaderComponent } from './job-status-header.component';
import { JobStatusSummarySearchComponent } from './job-status-summary-search.component';
import { JobStatusSummaryComponent } from './job-status-summary.component';
import { JobStatusComponent } from './job-status.component';
import { PaginationComponent } from './pagination.component';
export const components: any[] = [
  JobStatusSummarySearchComponent,
  JobStatusSummaryComponent,
  PaginationComponent,
  JobStatusComponent,
  JobStatusHeaderComponent
];

export * from './job-status-summary-search.component';
export * from './job-status-summary.component';
export * from './pagination.component';
export * from './job-status.component';
export * from './job-status-header.component';
